



























































































































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import util from "@/lib/util";
import ajax from "axios";
import {
    GetSqlTempData
} from "@/api/systemBasic";
import {
    DeleteAppoinment,
    BatchDeleteAppoinment,
    BatchPasteAppoinment,
    AllowInsertFollowForm
} from "@/api/follow/followUpAppointment";
import {GetDicsByCode} from "@/api/systemBasic"
import copyDataDetailed from "./copyDataDetailed.vue";
import editAppointment from "./edit.vue";
import addAppointment from "./add.vue";
import FollowFormDetail from "../patientFollow/detail.vue";
import FollowFormForSql from "../followForm/followFormForSql.vue";

@Component({  components: { copyDataDetailed,editAppointment,addAppointment,FollowFormDetail,FollowFormForSql },})
export default class extends AbpBase {
    DateTitle="";
    DateIndex=0;
    data: any[] = [];
    selectData:any={};
    patientName="";
    followUpContent="";
    followUpContents: any[] = [];
    dataDetailed:any[] = [];
    cobyDatas:any = {};
    selectedTableRow: any[] = [];
    copyDataShow = false;
    editShow = false;
    editAppointmentData:any={};
    addShow = false;
    addAppointmentData:any={};
    showFollowFormDetail=false;
    showFollowFormForSql=false;
    patientforSQl:any={};
    FollowTitle="";
    followFormId:number=0;
    followUpUserSql=util.abp.setting.get("followUpUserSql")=='1';
    loading=false;
    detailColumn = [
    {
        type: "selection",
        width: 60,
        align: "center",
    },
    {
        title: "患者姓名",
        key: "PatientName",
        width: 110,
    },
    {
    title: "随访内容",
    key: "FollowUpContent",
    minWidth: 150,
    },
    {
    title: "操作",
    width: 220,
    render: (h1: any, params: any) => {
        const h = this.$createElement;
        let isdefaultDom: any;
        return h("div", [
            isdefaultDom,
            h(
                "Button",
                {
                props: {
                    type: "primary",
                    size: "small",
                },
                style: {
                    marginRight: "5px",
                },
                on: {
                    click: () => {
                    this.editData(params.row);
                    },
                },
                },
                "编辑"
            ),
            h(
                "Button",
                {
                props: { type: "error", size: "small" },
                style: {
                    marginRight: "5px",
                },
                on: {
                    click: () => {
                        this.delData(params.row);
                    },
                },
                },
                "删除"
            ),
            h(
                "Button",
                {
                props: { type:  params.row.FollowFormId?"error":"info", size: "small" },
                on: {
                    click: () => {
                    this.addFollowForm(params.row);
                    }
                }
                },
                params.row.FollowFormId?"已随访":"随访"
            )
            ]);
        },
        },
    ];
    //表格高度
    get tableHeight() {
        return window.innerHeight - 100;
    }
    async created() {
        this.getSelects()
        this.getData()
    }
    // 获取所有下拉
    async getSelects() {
       	let res = await GetDicsByCode({code: 'PD_Dic_Follow_Up_Appointment'})
        this.followUpContents = res.objects;
    }

    async getData(){
        this.selectedTableRow=[];

        let res = await GetSqlTempData(this.getQuery());
        if (res.objects.jsonText && res.objects.jsonText.length > 0) {
            this.data = JSON.parse(res.objects.jsonText);
        } else {
            this.data = [];
        }
        var title = this.data.find((x) => {
            return x.InMonth;
        });
        if(title){
            this.DateTitle = title.Month;
        }
    }

    async getDataDetailed(){
        this.selectedTableRow = [];
        let res = await GetSqlTempData(this.getQueryDetailed());
        if (res.objects.jsonText && res.objects.jsonText.length > 0) {
            this.dataDetailed = JSON.parse(res.objects.jsonText);
        } else {
            this.dataDetailed = [];
        }
    }
    async refreshData(){
        this.loading=true;
        this.getData();
        this.getDataDetailed();
        this.loading=false;
    }
    private getQuery() {
        var queryList=[];
        queryList.push({
            title: "DateIndex",
            valueStr: this.DateIndex,
            id: 0,
            isLastSave: false,
            lastSaveValue: ""
        })
        var queryJson = JSON.stringify(queryList);
        let query = {
            QueryJson: queryJson,
            SqlName: "随访预约记录日历",
        };
        
        return query;
    }

    private getQueryDetailed() {
        var queryList=[];
        queryList.push({
            title: "PatientName",
            valueStr: this.patientName,
            id: 0,
            isLastSave: false,
            lastSaveValue: ""
        })
         queryList.push({
            title: "FollowUpContent",
            valueStr: this.followUpContent,
            id: 0,
            isLastSave: false,
            lastSaveValue: ""
        })
         queryList.push({
            title: "SelectDate",
            valueStr: this.selectData.Date,
            id: 0,
            isLastSave: false,
            lastSaveValue: ""
        })
        var queryJson = JSON.stringify(queryList);
        let query = {
            QueryJson: queryJson,
            SqlName: "随访预约记录单天明细",
        };
        
        return query;
    }

    dateup(){
        this.DateIndex+=1;
        this.getData();
    }

    datelow(){
        this.DateIndex+=-1;
        this.getData();
    }

    datetoday(){
        this.DateIndex=0;
        this.getData();
    }

    async changeContent(data:any){
        this.patientName="";
        this.followUpContent="";
        this.selectData=data;
     //   if(this.DateTitle>data.Month)
     //   {
     //       this.datelow();
     //   }
     //   else if(this.DateTitle<data.Month)
     //   {
     //       this.dateup();
     //   }
        this.selectData=data;
        this.getDataDetailed();
    }

    tableSelectionChange(selection: any) {
        this.selectedTableRow = selection;
    }
    addData()
    {
        this.addAppointmentData.Date = this.selectData.Date
        this.addShow=true;
    }
    editData(row:any){
        this.editAppointmentData = row;
        this.editAppointmentData.saveType = "编辑";
        this.editAppointmentData.Date = this.selectData.Date;
        this.editShow=true;
    }
    async delData(row:any){
        this.$Modal.confirm({
        title: "提示",
        content: "此操作将永久删除该预约记录, 是否继续?",
        onOk: async () => {
            let res = await DeleteAppoinment({ Id: row.Id });
            this.refreshData();
        },
        });
    }
    async batchDelete()
    {
        this.$Modal.confirm({
        title: "提示",
        content: "此操作将永久删除该预约记录, 是否继续?",
        onOk: async () => {
            this.loading=true;
            let idList = this.selectedTableRow.map((row) => {
                return row.Id;
            });
            let res = await BatchDeleteAppoinment({ IdList: idList });
            this.refreshData();
        },
        });
    }
    async cobyData(){
        if(this.selectedTableRow.length<=0) {
            this.$Message.error("请勾选需要复制的患者！");
            return;
        }
        this.$Modal.confirm({
            title: "提示",
            content: "确定要复制“"+this.selectData.Date+"”中勾选的预约随访内容吗？",
            onOk:async  () => {
                this.cobyDatas={};
                this.cobyDatas = this.selectData;
                let cobyData = this.selectedTableRow.map((row) => {
                    return row;
                });
                this.cobyDatas.cobyData = cobyData;
            },
        });
    }
    showCobyData(){
        this.copyDataShow=true;
    }
    async pasteData()
    {
        if(this.selectData.Date==this.cobyDatas.Date){
            this.$Message.error("同一天不能粘贴！");
            return;
        }
        this.$Modal.confirm({
        title: "提示",
        content: "“"+this.cobyDatas.Date+"”粘贴至“"+this.selectData.Date+"”，此操作将覆盖“"+this.selectData.Date+"”预约记录, 是否继续?",
        onOk: async () => {
            this.loading=true;
            let idList = this.cobyDatas.cobyData.map((row) => {
                return row.Id;
            });
            let res = await BatchPasteAppoinment({ IdList: idList,Date : this.selectData.Date });
            this.refreshData();
        },
        });
    }
    handleFollowFormSubmited() {
        this.showFollowFormDetail = false;
        this.refreshData();
    }
    //提交随访表单
    handleFollowFormSubmit() {
        this.$refs.followFormDetail.submit();
        this.refreshData();
    }
     // 新增随访
    async addFollowForm(row: any) {
        this.patientforSQl={id:row.PatientId,name:this.selectData.Date+" "+row.PatientName +" 随访",pD_Patient_ID:row.PatientId};
        this.followFormId = row.FollowFormId;
        if(this.followUpUserSql){
            this.showFollowFormForSql=true;
        }else{
        // 判断患者是否可以随访
        let res = await AllowInsertFollowForm(row.PatientId);
        if (res.code != 2000) {
            this.$Modal.error({
            title: "提示",
            content: res.message
            });
        } else {
            this.FollowTitle= this.selectData.Date+" "+row.PatientName +" 随访";
            this.showFollowFormDetail = true;
        }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followUpAppointment/index.vue